<template>
    <v-container align-start>
        <v-form
            class="form-question"
            v-model="valid"
            ref="form"
            @submit.native.prevent="next"
        >
            <v-layout v-for="(item, index) in items" :key="index" column>
                <p v-if="isVerification">{{ item }}</p>
                <v-select
                    v-else
                    v-model="selectQes[index]"
                    :rules="[v => !!v || lang.empty_question_tips]"
                    :items="options[index]"
                    :label="lang.security_question_label + (index + 1)"
                    solo
                ></v-select>
                <v-text-field
                    v-model.trim="selectAns[index]"
                    :rules="[
                        () => !!selectAns[index] || lang.empty_answer_tips
                    ]"
                    :readonly="pageLoading"
                    :label="lang.answer_placeholder"
                    solo
                ></v-text-field>
            </v-layout>
            <v-btn
                block
                :disabled="!valid || isError"
                class="btn-h48"
                color="primary"
                @click="next"
            >
                {{ buttonText }}
            </v-btn>
            <v-btn
                class="ma-0 right"
                color="primary"
                flat
                small
                @click="choseVType"
                v-if="isVerification && isOtherVerificationTypeShow"
            >
                {{ lang.use_other_verification_type_text }}
            </v-btn>
            <p class="error--text caption pa-1 ml-2" v-if="isError">
                {{ lang.iscorrect_answer_tips }}
            </p>
        </v-form>
        <q-dialog
            :visible.sync="dialogVisible"
            active="question"
            v-if="isOtherVerificationTypeShow"
        ></q-dialog>
        <v-dialog v-model="alertVisible">
            <v-card :color="alertType" dark>
                <v-card-text>
                    <v-layout align-center>
                        <span>{{ lang["submit_" + alertType + "_tips"] }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="white"
                            fab
                            small
                            light
                            @click="alertVisible = false"
                        >
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import QDialog from "@/components/QDialog";
export default {
    name: "Question",
    components: {
        QDialog
    },
    data() {
        return {
            alertVisible: false,
            alertType: "",
            dialogVisible: false,
            selectQes: [],
            selectAns: [],
            valid: false,
            isError: false
        };
    },
    computed: {
        ...mapState([
            "authVerifiedType",
            "pageParent",
            "pageLoading",
            "params"
        ]),
        ...mapGetters(["lang", "securityObj", "settedSecurities"]),
        isOtherVerificationTypeShow() {
            return this.settedSecurities.length > 1;
        },
        bindingValue() {
            return this.securityObj.question.value;
        },
        isVerification() {
            return (
                !this.authVerifiedType ||
                this.authVerifiedType === "verification"
            );
        },
        buttonText() {
            return !this.isVerification
                ? this.lang.submit_text
                : this.lang.next_step_text;
        },
        srcOptions() {
            return this.lang.security_question_options.map((text, i) => {
                return {
                    text,
                    value: i + 1,
                    disabled: false
                };
            });
        },
        qes1st() {
            let selected = this.selectQes.slice(1);
            return this.srcOptions.map(item => {
                return Object.assign({}, item, {
                    disabled: selected.indexOf(item.value) > -1
                });
            });
        },
        qes2nd() {
            let selected = [this.selectQes[0], this.selectQes[2]].filter(
                v => v
            );
            return this.srcOptions.map(item => {
                return Object.assign({}, item, {
                    disabled: selected.indexOf(item.value) > -1
                });
            });
        },
        qes3rd() {
            let selected = this.selectQes.slice(0, 2);
            return this.srcOptions.map(item => {
                return Object.assign({}, item, {
                    disabled: selected.indexOf(item.value) > -1
                });
            });
        },
        options() {
            return [this.qes1st, this.qes2nd, this.qes3rd];
        },
        items() {
            return this.isVerification ? this.bindingValue : [1, 2, 3];
        },
        action() {
            let tmp;
            if (this.isVerification) {
                tmp =
                    this.pageParent === "password"
                        ? this.verifyQaFFTR
                        : this.verifyQaFVS;
                return tmp;
            }
            switch (this.authVerifiedType) {
                case "password":
                    tmp = this.setSecurityFPTS;
                    break;
                case "email":
                    tmp = this.setSecurityFSTS;
                    break;
                case "mobile":
                    tmp = this.setSecurityFSTS;
                    break;
                case "question":
                    tmp = this.setSecurityFSTS;
                    break;
            }
            return tmp;
        }
    },
    watch: {
        selectAns() {
            this.isError = false;
        },
        alertVisible(val) {
            if (!val) {
                this.changeAuthVerified("");
                this.$router.push({
                    name: "security",
                    query: Object.assign({}, this.params, {
                        t: Date.now()
                    })
                });
            }
        }
    },
    methods: {
        ...mapActions([
            "verifyQaFVS",
            "verifyQaFFTR",
            "setSecurityFPTS",
            "setSecurityFSTS"
        ]),
        ...mapMutations({
            changePageLoading: "CHANGE_PAGE_LOADING",
            changeAuthVerified: "CHANGE_AUTH_VERIFIED"
        }),
        choseVType() {
            if (this.pageLoading) {
                return;
            }
            this.dialogVisible = true;
        },
        next() {
            let params;
            if (this.pageLoading) {
                return;
            }
            this.changePageLoading(true);
            if (this.isVerification) {
                params = {
                    type: "qa",
                    security_q1: this.bindingValue[0],
                    security_q2: this.bindingValue[1],
                    security_a1: this.selectAns[0],
                    security_a2: this.selectAns[1]
                };
            } else {
                params = {
                    type: "qa",
                    security_q1: this.srcOptions[this.selectQes[0] - 1].text,
                    security_q2: this.srcOptions[this.selectQes[1] - 1].text,
                    security_q3: this.srcOptions[this.selectQes[2] - 1].text,
                    security_a1: this.selectAns[0],
                    security_a2: this.selectAns[1],
                    security_a3: this.selectAns[2]
                };
            }
            this.action(params)
                .then(() => {
                    if (this.isVerification) {
                        this.changeAuthVerified("question");
                        this.$router.push({
                            name: this.$route.query.redirect,
                            query: Object.assign({}, this.params, {
                                t: Date.now()
                            })
                        });
                    } else {
                        this.alertVisible = true;
                        this.alertType = "success";
                    }
                })
                .catch(err => {
                    if (err.code === 1002) {
                        this.isError = true;
                    } else if (err.code === 1003) {
                        this.alertVisible = true;
                        this.alertType = "error";
                    }
                    setTimeout(() => {
                        this.changePageLoading(false);
                        this.$refs.form.validate();
                    }, 300);
                });
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.form.reset();
        next();
    }
};
</script>
<style lang="scss" scoped>
.form-question {
    p.error--text {
    }
}
</style>
